import { Button } from "@izicvs/ui";
import { t } from "@lingui/macro";
import { ArrowRight, BookOpen, LifeBuoy, Mail, MessageSquarePlus } from "lucide-react";
import { Link } from "react-router";

import { Seo } from "@/client/components/seo";

import { IconBadge, PageHero, Section } from "../_components/page-shell";

const cardClassName =
  "rounded-2xl border border-border bg-background p-6 transition-all duration-300 hover:-translate-y-1 hover:border-primary/30 hover:shadow-xl hover:shadow-primary/5";

export const ContactPage = () => {
  return (
    <>
      <Seo
        title={t`Contact Izicvs`}
        description={t`Questions, feedback or partnership? The Izicvs team typically replies within 24 hours on business days.`}
        path="/contact"
        breadcrumb={t`Contact`}
      />

      <PageHero
        eyebrow={t`Contact`}
        title={t`Get in touch`}
        subtitle={t`Questions, feedback, or just saying hello? The Izicvs team is here for you and typically replies within 24 hours on business days.`}
      />

      <Section>
        <div className="mx-auto grid max-w-5xl gap-6 sm:grid-cols-2">
          <div className={cardClassName}>
            <IconBadge icon={Mail} />
            <h2 className="mt-4 text-lg font-semibold text-neutral-800 dark:text-neutral-100">
              {t`General inquiries`}
            </h2>
            <p className="mt-2 text-sm leading-relaxed text-neutral-600 dark:text-neutral-400">
              {t`Partnerships, press, or anything else on your mind. Drop us a line and we will get back to you.`}
            </p>
            <a
              href="mailto:hello@izicvs.com"
              className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary hover:underline"
            >
              hello@izicvs.com
              <ArrowRight className="size-4" aria-hidden="true" />
            </a>
          </div>

          <div className={cardClassName}>
            <IconBadge icon={LifeBuoy} />
            <h2 className="mt-4 text-lg font-semibold text-neutral-800 dark:text-neutral-100">
              {t`Account support`}
            </h2>
            <p className="mt-2 text-sm leading-relaxed text-neutral-600 dark:text-neutral-400">
              {t`Trouble with your account, billing, or a feature? Our support team will help you sort it out quickly.`}
            </p>
            <a
              href="mailto:support@izicvs.com"
              className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary hover:underline"
            >
              support@izicvs.com
              <ArrowRight className="size-4" aria-hidden="true" />
            </a>
          </div>

          <div className={cardClassName}>
            <IconBadge icon={BookOpen} />
            <h2 className="mt-4 text-lg font-semibold text-neutral-800 dark:text-neutral-100">
              {t`Help Center`}
            </h2>
            <p className="mt-2 text-sm leading-relaxed text-neutral-600 dark:text-neutral-400">
              {t`Browse guides and answers to common questions. It is the fastest way to get unstuck on your own.`}
            </p>
            <div className="mt-4">
              <Button asChild variant="outline" size="sm">
                <Link to="/help">{t`Visit the Help Center`}</Link>
              </Button>
            </div>
          </div>

          <div className={cardClassName}>
            <IconBadge icon={MessageSquarePlus} />
            <h2 className="mt-4 text-lg font-semibold text-neutral-800 dark:text-neutral-100">
              {t`Share a suggestion`}
            </h2>
            <p className="mt-2 text-sm leading-relaxed text-neutral-600 dark:text-neutral-400">
              {t`Have an idea that would make Izicvs better? We build with our users, so we would love to hear it.`}
            </p>
            <div className="mt-4">
              <Button asChild variant="outline" size="sm">
                <Link to="/feedback">{t`Send feedback`}</Link>
              </Button>
            </div>
          </div>
        </div>
      </Section>
    </>
  );
};
